import { Link } from "react-router";
import logoSIADark from "@assets/events-awards/logo-sia-dark.png";
import Column from "@components/Grid/Column";
import Row from "@components/Grid/Row";
import { EVENTS_AWARDS_SIA_PATH } from "@events-awards/utils/constants";

import { siaFooterMenu } from "./SIAConstants";

/**
 * Component to display footer in SIA pages
 */
const SIAFooter = () => {
  return (
    <footer
      data-testdata-testid="events-sia-foetr-component"
      className="mb-4 flex flex-row justify-center bg-gray-850 py-8 text-white"
    >
      <Row rootClassName="w-full lg:w-8/12 lg:flex text-center my-8 hidden">
        <Column>
          <Link to={EVENTS_AWARDS_SIA_PATH}>
            <img
              src={logoSIADark}
              alt="Sustainability Impact Awards logo"
              width={200}
            />
          </Link>
        </Column>

        <Column rootClassName="flex-1">
          <h3 className="mb-4 text-left text-lg font-semibold">About Us</h3>

          <p className="text-left text-gray-300">
            The Sustainability Impact Awards (SI Awards), launched on 1 February
            2023, is jointly presented by The Business Times and UOB, with the
            Centre for Governance and Sustainability (CGS) at the National
            University of Singapore Business School as the knowledge partner.
          </p>
        </Column>

        <Column>
          <p className="mb-4 text-left font-semibold">Sections</p>

          <Column rootClassName="space-y-2">
            <Row>
              <Column rootClassName="flex flex-col px-0">
                {siaFooterMenu.slice(0, 3).map((item) => {
                  return (
                    <Link
                      to={`${item.link}?ref=footer`}
                      key={item.label}
                      className="text-left text-gray-300 transition-colors hover:text-white"
                      reloadDocument
                    >
                      {item.label}
                    </Link>
                  );
                })}
              </Column>

              <Column rootClassName="flex flex-col">
                {siaFooterMenu.slice(3, 5).map((item) => {
                  return (
                    <Link
                      to={`${item.link}?ref=footer`}
                      className="text-left text-gray-300 transition-colors hover:text-white"
                      key={item.label}
                      reloadDocument
                    >
                      {item.label}
                    </Link>
                  );
                })}
              </Column>
            </Row>
          </Column>
        </Column>

        <Column>
          <p className="mb-4 text-left font-semibold">Quick Links</p>

          <Column rootClassName="space-y-2 flex flex-col px-0">
            {siaFooterMenu.slice(5, 8).map((item) => {
              return (
                <Link
                  to={`${item.link}?ref=footer`}
                  key={item.label}
                  className="text-left text-gray-300 transition-colors hover:text-white"
                  reloadDocument
                >
                  {item.label}
                </Link>
              );
            })}
          </Column>
        </Column>
      </Row>

      <Row rootClassName="w-full text-center px-3 lg:hidden">
        <Column rootClassName="w-full flex flex-col justify-center items-center mb-6">
          <Link to={EVENTS_AWARDS_SIA_PATH}>
            <img
              src={logoSIADark}
              alt="Sustainability Impact Awards logo"
              width={200}
            />
          </Link>
        </Column>

        <Column rootClassName="my-6 px-0">
          <h3 className="mb-4 text-left text-lg font-semibold">About Us</h3>

          <p className="text-left text-sm text-gray-300">
            The Sustainability Impact Awards (SI Awards), launched on 1 February
            2023, is jointly presented by The Business Times and UOB, with the
            Centre for Governance and Sustainability (CGS) at the National
            University of Singapore Business School as the knowledge partner.
          </p>
        </Column>

        <Row rootClassName="w-full -mx-0 mt-6">
          <Column rootClassName="w-1/2">
            <h3 className="mb-4 text-left text-lg font-semibold">Sections</h3>

            <Column>
              <Row>
                <Column rootClassName="flex flex-col px-0">
                  {siaFooterMenu.slice(0, 5).map((item) => {
                    return (
                      <Link
                        to={`${item.link}?ref=footer`}
                        key={item.label}
                        className="text-left text-sm text-gray-300 transition-colors hover:text-white"
                        reloadDocument
                      >
                        {item.label}
                      </Link>
                    );
                  })}
                </Column>
              </Row>
            </Column>
          </Column>

          <Column rootClassName="w-1/2">
            <h3 className="mb-4 text-left text-lg font-semibold">
              Quick Links
            </h3>

            <Column rootClassName="flex flex-col px-0">
              {siaFooterMenu.slice(5, 8).map((item) => {
                return (
                  <Link
                    to={`${item.link}?ref=footer`}
                    key={item.label}
                    className="text-left text-sm text-gray-300 transition-colors hover:text-white"
                    reloadDocument
                  >
                    {item.label}
                  </Link>
                );
              })}
            </Column>
          </Column>
        </Row>
      </Row>
    </footer>
  );
};

export default SIAFooter;
